import React, { FC } from 'react'
import ReactQuill from 'react-quill'
import { cn } from 'shared/utils'
import { useController } from 'react-hook-form'
import { toolbarModules } from 'shared/quill/editorOptions'
import { IProjectForm } from '../../types'
import { FieldProps } from './FieldInformation.props'
import styles from './field-information.module.scss'

const FieldInformation: FC<FieldProps> = ({
  title,
  control,
  name,
  children,
  content,
  size = 'default',
  dimensions = 'default'
}) => {
  const {
    field: { value, onChange }
  } = useController<IProjectForm, typeof name>({ name, control })

  return (
    <section
      className={
        size === 'full'
          ? styles.block
          : cn(styles.container, {
            [styles.small]: dimensions === 'small'
          })
      }
    >
      <h3 className={styles.title}>{title}</h3>
      <div className={styles.left}>
        <ReactQuill theme="snow" value={value} onChange={onChange} modules={toolbarModules.minimal} />
        {content}
      </div>
      <div className={styles.right}>{children}</div>
    </section>
  )
}

export default FieldInformation
